import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export default function CheckboxListField<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <>CheckboxListField<pre>{JSON.stringify(props, null, 4)}</pre></>;
}
